import dynamic from "next/dynamic";
import MondayDemoTabsConfig from "./monday-demo-tabs-config";
import MondayDemoTabsAdvancedConfig from "./monday-demo-tabs-advanced-config";
const MondayDemoTabsComponent = dynamic(()=>import("./monday-demo-tabs-component"));
export default {
    MondayDemoTabsComponent,
    MondayDemoTabsConfig,
    MondayDemoTabsAdvancedConfig
};
